// extracted by mini-css-extract-plugin
module.exports = {"embed":"Embed--embed--2Ww5t","offset":"Embed--offset--3iYYN","embed__content":"Embed--embed__content--2uDyG"};